import { z } from 'zod';
export const MergeRequestDTO = z.object({
    iid: z.number(),
    title: z.string(),
    sourceBranch: z.string(),
    targetBranch: z.string(),
    authorName: z.string(),
    webUrl: z.string(),
    draft: z.boolean(),
    updatedAt: z.string(),
    description: z.string(),
    labels: z.array(z.string()),
});
export const MergeRequestsResponse = z.array(MergeRequestDTO);
export const MergeRequestDetailDTO = MergeRequestDTO.extend({
    sha: z.string(),
    hasConflicts: z.boolean(),
    detailedMergeStatus: z.string(),
    pipelineStatus: z.string().nullable(),
    canMerge: z.boolean(),
});
export const MergeMergeRequestResponse = z.object({
    state: z.string(),
    mergeCommitSha: z.string().nullable(),
});
//# sourceMappingURL=mergeRequest.js.map